// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import Main from '../views/main'
// import Preview from '../views/main/components/preview'
// import Share from '../views/main/components/share'
// import Record from '../views/weixinRecord'
// import Template from '../views/template'
// import Bridge from '../views/bridge'

// Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'template',
    component: () => import('../views/template')
  },
  {
    path: '/bridge',
    name: 'Bridge',
    component: () => import('../views/bridge')
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/main')
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import('../views/main/components/preview')
  },
  {
    path: '/share',
    name: 'Share',
    component: () => import('../views/main/components/share')
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import('../views/weixinRecord')
  },
]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
